<template>
  <div>
    <Empty class="empty-custom-image"
           image="https://img.yzcdn.cn/vant/custom-empty-image.png"
           :description="desc"
    />
  </div>
</template>

<script>

  import {Empty} from "vant"

  export default {
    name: "EmptyBox",
    props: {
      desc: {}
    },
    components: {
      Empty
    }
  }

</script>

<style lang="scss" scoped>
  .empty-custom-image .van-empty__image {
    width: 90px;
    height: 90px;
  }
</style>
